import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Select from '../common/form-elements/form-select/form-select'
import styles from './color-select.styles'
import classNames from 'classnames'

class ColorSelect extends Component {
  optionRenderer(option) {
    const { classes } = this.props
    return (
      <span
        className={classes.option}
        style={{ backgroundColor: option.color }}
      />
    )
  }
  valueRenderer(option) {
    const { classes } = this.props
    return (
      <span
        className={classes.value}
        style={{ backgroundColor: option.color }}
      />
    )
  }
  render() {
    const { classes, value, options, onChange, className } = this.props
    return (
      <Select
        onChange={onChange}
        className={classNames(classes.colorSelect, className)}
        selectProps={{
          optionRenderer: option => this.optionRenderer(option),
          valueRenderer: option => this.valueRenderer(option)
        }}
        value={value}
        options={options}
      />
    )
  }
}

export default injectSheet(styles)(ColorSelect)
